/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { DataTable, List, Paragraph, useTheme } from "react-native-paper";
import { PROFILE_BENE } from "../../../../../modules/beneficiaries/utils/bene.utils";
import { spacing } from "@styles/spacing";
import { useMobileMediaQuery } from "@media-query";
import { Block } from "@block";
import { FlatListItem } from "../select-account-bene.modal";
import { Constant } from "../../../../constant/constant";
import { getBank247, getBankForeign, getStock } from "../../../../../modules/transfer/transfer-utils/transfer.utils";
import { getTopUpService } from "../../../../../modules/top-up/top-up-utils/top-up.utils";
import { useSelector } from "react-redux";
import { getTransferInfoSelector } from "../../../../../modules/transfer/reducer/selectors";
import { getBillingService } from "app/modules/billings/billing-utils/billing-utils";

interface ItemModalProps {
  item: FlatListItem;
  index: number;
  templateType?: string;
  onClick?: Function;
}

interface InfoItemData {
  title: string;
  label: string;
  value: string;
  description: string;
}

const ItemBene = (props: ItemModalProps) => {
  const { item, index, templateType, onClick } = props;
  const { colors, fonts } = useTheme();
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslation();

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        titleModal: {
          color: colors.accent,
        },
        styleDescription: {
          color: colors.placeholder,
          fontStyle: "italic",
        },
      }),
    [colors.accent, colors.placeholder],
  );

  const transferInfo = useSelector(getTransferInfoSelector);

  const onPressItem = () => {
    if (onClick) onClick(item);
  };

  const getInfoBene = (): InfoItemData => {
    const bene: PROFILE_BENE = item.data || {};
    if (templateType === bene?.TEMPLATE_TYPE) {
      let bankName = "";
      let serviceName = "";
      let stockName = "";
      switch (bene?.TEMPLATE_TYPE) {
        case Constant.TEMPLATE_TYPE.INTERNAL_TRANSFER:
          return { title: bene.NAME || "", label: t("BENE_SO_TAI_KHOAN"), value: bene.ACCOUNT_NUMBER || "", description: "PVComBank" };
        case Constant.TEMPLATE_TYPE.INTERBANK_TRANSFER:
          bankName = getBankForeign(bene.BANK_NAME?.substr(2, 3))?.NODE_SHORTNAME || "";
          return { title: bene.NAME || "", label: t("BENE_SO_TAI_KHOAN"), value: bene.ACCOUNT_NUMBER || "", description: bankName };
        case Constant.TEMPLATE_TYPE.INTERBANK_FAST_TRANSFER:
          bankName = getBank247(bene.BANK_NAME)?.label || "";
          return {
            title: bene.NAME || "",
            label: t("BENE_SO_TAI_KHOAN_SO_THE"),
            value: bene.ACCOUNT_NUMBER || bene.CARD_NUMBER || "",
            description: bankName,
          };
        case Constant.TEMPLATE_TYPE.DEPOSIT_TO_STOCK_TRADE_ACCOUNT:
          stockName = getStock(transferInfo, bene.COMPANY_NAME)?.label || "";
          return {
            title: bene.NAME || "",
            label: t("BENE_SO_TAI_KHOAN"),
            value: bene.ACCOUNT_NUMBER || "",
            description: stockName,
          };
        case Constant.TEMPLATE_TYPE.TOP_UP_TEMPLATE:
          serviceName = getTopUpService(bene.SERVICE)?.NAME || "";
          return {
            title: bene.NAME || "",
            label: t("BENE_SO_DIEN_THOAI_TAI_KHOAN_DICH_VU"),
            value: bene.CUSTOMER_CODE || bene.PHONE || "",
            description: serviceName,
          };
        case Constant.TEMPLATE_TYPE.BILLING_TEMPLATE:
          serviceName = getBillingService(bene.SERVICE)?.NAME || "";
          return { title: bene.NAME || "", label: t("BENE_MA_HD_KH_SDT"), value: bene.CUSTOMER_CODE || "", description: serviceName };
        default:
          return { title: "", label: "", value: "", description: "" };
      }
    }
    return { title: "", label: "", value: "", description: "" };
  };

  const TitleItem = (info: InfoItemData) => (
    <DataTable style={{ paddingRight: spacing.small }}>
      <DataTable.Header style={{ flex: 1, paddingHorizontal: 0, paddingVertical: 0, borderWidth: 0, borderBottomWidth: 0 }}>
        <DataTable.Title style={{ flex: 1, paddingVertical: 0 }}>
          <Paragraph style={[fonts.regular, { color: colors.text, paddingVertical: 0 }]}>{info.title}</Paragraph>
        </DataTable.Title>
        {!isMobile ? (
          <DataTable.Title style={{ position: "absolute", right: spacing.small, paddingVertical: 0 }}>
            <Paragraph style={[fonts.regular, { color: colors.text }]}>{info.value}</Paragraph>
          </DataTable.Title>
        ) : null}
      </DataTable.Header>
    </DataTable>
  );

  const RowDescription = (info: InfoItemData) =>
    isMobile ? (
      <Block pv={spacing.micro}>
        <Paragraph style={[fonts.regular, { flex: 1, color: colors.text }]}>{info.description}</Paragraph>
        <Paragraph style={[fonts.regular, { color: colors.placeholder, fontStyle: "italic" }]}>
          {info.label}
          {":  "}
          <Paragraph style={[fonts.regular, { color: colors.text, fontStyle: "normal" }]}>{info.value}</Paragraph>
        </Paragraph>
      </Block>
    ) : (
      <Paragraph style={[fonts.regular, styles.styleDescription]}>{info.description}</Paragraph>
    );

  const renderItem = () => {
    const info = getInfoBene();
    return (
      <List.Item
        style={{
          minHeight: spacing.galactic,
          backgroundColor: index % 2 === 0 ? colors.surface : colors.select,
          justifyContent: "center",
          padding: 0,
        }}
        title={TitleItem(info)}
        description={RowDescription(info)}
        onPress={() => {
          if (item.data) onPressItem();
        }}
        titleStyle={{
          fontWeight: "700",
          color: colors.text,
        }}
      />
    );
  };

  return renderItem();
};

export default ItemBene;
